import React, { Component } from 'react';
import { Container } from 'reactstrap';
import DataWrapper from './../../../principal/containers/DataWrapper';
import { inject, observer } from 'mobx-react';
import Footer from '../../../comum/components/Footer';
import FooterContent from '../../../comum/components/FooterContent';
import { TabelaRelSintetico } from './../components/TabelaRelSintetico';
import ExportExcelSintetico from './../components/ExportExcelSintetico';
import { FiltroRelSintetico } from '../components/FiltroRelSintetico';
import RelatorioSinteticoStore from './../stores/RelatorioSinteticoStore';
import LoadingImage from '../../../comum/components/LoadingImage';
import FooterOptions from '../../../comum/components/FooterOptions';
import IconButton from '../../../comum/components/IconButton';
import { makePDF } from '../../../../utils/formatar';


@inject("store")
@DataWrapper
@observer
export class RelatorioSintetico extends Component {

    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.controller = new RelatorioSinteticoStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Relatório Sintético");
    };

    render() {
        let pdfData = this.controller.colunas.slice();
        return (<div>
            <Container fluid>
                 {
                     this.controller.loadingPage
                     ? <LoadingImage tamanho="2x" />
                     :<React.Fragment>
                         <FiltroRelSintetico controller={this.controller} />
                         <TabelaRelSintetico controller={this.controller} />
                     </React.Fragment>
                 }
                 <Footer>
                     <FooterContent>
                    {
                        this.controller.listaEntrepostagem.length > 0
                        ? <div className="justify-content-between">
                            <div>
                                <b>{this.controller.listaEntrepostagem.length}</b> Registros no Total
                                {this.controller.listaEntrepostagem
                                    && <React.Fragment>
                                        - <a onClick={() => this.controller.listarEntrepostagem()} >Atualizar Lista</a>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        : null
                    }
                     </FooterContent>
                     <FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.listaEntrepostagem.length===0}
                                onClick={
                                    () => makePDF(
                                        this.controller.listaEntrepostagem,
                                        pdfData.map(elem => elem.dataField),
                                        pdfData.map(elem => elem.text),
                                        ["DtValidade","DtAbandono"],
                                        true,
                                        false,
                                        {qtdColFixo: "A4", nomeDoArquivo: "Relatório Sintético - Entreposto.pdf", format: [{param:"IndStatus", formatter: this.controller.statusFormatter}]}
                                    )
                                }
                            />
                        </div>
                        <div>
                            <ExportExcelSintetico controller={this.controller} />
                        </div>
                     </FooterOptions>
                 </Footer>
            </Container>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatoriosintetico/telas/RelatorioSintetico.js